<template>
  <qx-card title="列表">
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
          </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import { normalizePaginationResponse } from 'api/paginationCompat';
import {
  queryOrderLogList,
} from 'api/operate';
export default {
  mixins: [
    tableMixin,
  ],
  data () {
    return {
      searchBoxData: {},
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'createDate',
            label: '创建时间',
          },
          {
            prop: 'operTypeName',
            label: '操作类型',
          },
          {
            prop: 'opName',
            label: '操作人',
          },
          {
            prop: 'operComment',
            label: '操作说明',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    async getList (params) {
      const response = await queryOrderLogList(params);
      return normalizePaginationResponse(response);
    },
    handleBeforeGetData () {
      this.searchBoxData = {
        orderId: this.$route.query.id,
        querySource: 1,
      };
    },
    // async getData () {
    //   const res = await queryOrderLogList({
    //     orderId: this.$route.query.id,
    //     querySource: 1,
    //   });
    //   this.listInfo.tableData.data = res.items;
    // },
  },
};
</script>

<style lang="scss" scoped>
</style>
